module.exports = __webpack_public_path__ + "img/moins.3c855561.svg";